import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { getLastUpdate } from '../../../../services/ProdutoService_ts';
import { LastIntegration } from '../types';

export const LAST_INTEGRATION_QUERY_KEY = 'last-update';

export const useLastIntegration = (): UseQueryResult<LastIntegration> =>
  // Same query key as the price manager, so both screens share the cached engine execution.
  useQuery<LastIntegration>({ queryKey: [LAST_INTEGRATION_QUERY_KEY], queryFn: getLastUpdate, retry: false });
